import React, { Component } from 'react';
import { Auth } from '../../services';
import { Globals } from '../../utils';

import Logo from '../../assets/img/logo.png';

import './reset-password.scss';

class ResetPassword extends Component {

  state = {
    code: '',
    codeValid: null,  // null = loading, true = válido, false = inválido
    form: {
      password: '',
      password_confirmation: '',
    },
    showPassword: false,
    showConfirm: false,
    strength: { label: 'Sin ingresar', className: '', width: 0 },
    passwordError: '',
    confirmError: '',
    success: false,
    submitting: false,
  }

  componentDidMount() {
    // Leemos el code desde el query string: ?code=...
    const params = new URLSearchParams(this.props.location.search);
    const code = params.get('code');

    if (!code) {
      this.setState({ codeValid: false });
      return;
    }
    // URLSearchParams decodifica automáticamente el query string, 
    // por lo que los caracteres especiales de base64 ya estarán bien formados.
    this.setState({ code }, () => this.validateCode());
  }

  validateCode = async () => {
    try {
      const res = await Auth.checkCode({ code: this.state.code });
      this.setState({ codeValid: res.result === true });
    } catch (e) {
      this.setState({ codeValid: false });
    }
  }

  onChange = (value, target) => {
    this.setState(state => ({
      form: { ...state.form, [target]: value }
    }), () => {
      if (target === 'password') {
        this.setState({
          strength: this.getStrength(value),
          passwordError: value.length > 0 && value.length < 6
            ? 'La contraseña debe tener mínimo 6 caracteres.'
            : '',
        });
        if (this.state.form.password_confirmation) {
          this.validateConfirmation(false);
        }
      }
      if (target === 'password_confirmation') {
        this.validateConfirmation(false);
      }
    });
  }

  isSimplePassword = (value) => {
    const lower = value.toLowerCase();
    const repeated = /^(.)\1+$/.test(lower);
    const onlyLetters = /^[a-z]+$/.test(lower);
    const onlyNumbers = /^\d+$/.test(lower);
    const common = ['abcdef', '123456', '654321', 'password', 'qwerty'];
    return repeated || onlyLetters || onlyNumbers || common.includes(lower);
  }

  getStrength = (value) => {
    if (!value) return { label: 'Sin ingresar', className: '', width: 0 };
    if (value.length < 6) return { label: 'Muy corta', className: 'basic', width: Math.max(12, value.length * 10) };
    if (this.isSimplePassword(value)) return { label: 'Básica', className: 'basic', width: value.length >= 8 ? 50 : 35 };
    if (value.length >= 8) return { label: 'Fuerte', className: 'strong', width: 100 };
    return { label: 'Media', className: 'medium', width: 75 };
  }

  validateConfirmation = (showEmptyError = true) => {
    const { password, password_confirmation } = this.state.form;
    if (!password_confirmation) {
      this.setState({ confirmError: showEmptyError ? 'Debes confirmar la contraseña.' : '' });
      return !showEmptyError;
    }
    if (password !== password_confirmation) {
      this.setState({ confirmError: 'Las contraseñas no coinciden.' });
      return false;
    }
    this.setState({ confirmError: '' });
    return true;
  }

  isValidForm = () => {
    const { password } = this.state.form;
    if (password.length < 6) {
      this.setState({ passwordError: 'La contraseña debe tener mínimo 6 caracteres.' });
      return false;
    }
    return this.validateConfirmation(true);
  }

  onSubmit = async (e) => {
    e.preventDefault();
    if (!this.isValidForm()) return;

    this.setState({ submitting: true });

    try {
      await Auth.resetPassword({
        code: this.state.code,
        password: this.state.form.password,
        password_confirmation: this.state.form.password_confirmation,
      });
      this.setState({ success: true, form: { password: '', password_confirmation: '' }, strength: this.getStrength('') });
    } catch (error) {
      Globals.showError(error?.error || 'Ha ocurrido un error, intente nuevamente.');
    }

    this.setState({ submitting: false });
  }

  goToLogin = (e) => {
    e.preventDefault();
    this.props.history.push('/login');
  }

  render() {
    const { form, showPassword, showConfirm, strength, passwordError, confirmError, success, codeValid, submitting } = this.state;

    return (
      <div id="reset-password-page">
        <main className="rp-page-wrap">
          <img className="rp-brand-logo" src={Logo} alt="Logo" />

          <section className="rp-card">
            <div className="rp-icon-circle">
              <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" width="52" height="52">
                <rect width="48" height="48" rx="24" fill="rgba(8,207,165,0.12)" />
                <path d="M24 14a7 7 0 0 0-7 7v2h-1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V25a2 2 0 0 0-2-2h-1v-2a7 7 0 0 0-7-7Zm0 2a5 5 0 0 1 5 5v2H19v-2a5 5 0 0 1 5-5Zm0 9a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z" fill="#00a98b" />
              </svg>
            </div>

            <h1 className="rp-title">Restablece tu <span>contraseña</span></h1>

            {/* Estado: cargando validación del código */}
            {codeValid === null && (
              <p className="rp-intro">Verificando enlace...</p>
            )}

            {/* Estado: código inválido / expirado */}
            {codeValid === false && (
              <div className="rp-invalid-message">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="10" stroke="#ef4444" strokeWidth="2" />
                  <path d="M12 7v5M12 16h.01" stroke="#ef4444" strokeWidth="2" strokeLinecap="round" />
                </svg>
                <div>
                  <strong>Enlace inválido o expirado.</strong>
                  <span>Solicita un nuevo enlace de recuperación desde la pantalla de inicio de sesión.</span>
                </div>
              </div>
            )}

            {/* Estado: éxito */}
            {codeValid === true && success && (
              <div className="rp-success-message">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="10" fill="#08cfa5" opacity="0.15" />
                  <path d="M7 12.5l3.5 3.5 6.5-7" stroke="#00a98b" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                <div>
                  <strong>¡Contraseña cambiada exitosamente!</strong>
                  <span>Ya puedes iniciar sesión con tu nueva contraseña.</span>
                </div>
              </div>
            )}

            {/* Formulario activo */}
            {codeValid === true && !success && (
              <>
                <p className="rp-intro">Ingresa y confirma tu nueva contraseña para recuperar el acceso a tu cuenta.</p>

                <form onSubmit={this.onSubmit} noValidate>
                  {/* Nueva contraseña */}
                  <div className="rp-field-group">
                    <label className="rp-label" htmlFor="rp-password">Nueva contraseña</label>
                    <div className="rp-input-wrap">
                      <svg className="rp-field-icon" viewBox="0 0 24 24" fill="none" width="20" height="20">
                        <path d="M19 11H5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2ZM7 11V7a5 5 0 0 1 10 0v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <circle cx="12" cy="16" r="1.5" fill="currentColor" />
                      </svg>
                      <input
                        id="rp-password"
                        type={showPassword ? 'text' : 'password'}
                        className={`rp-input${passwordError ? ' rp-input--error' : ''}`}
                        placeholder="Ingresa tu nueva contraseña"
                        value={form.password}
                        onChange={e => this.onChange(e.target.value, 'password')}
                        autoComplete="new-password"
                        minLength={6}
                      />
                      <button
                        type="button"
                        className="rp-toggle-btn"
                        aria-label="Mostrar u ocultar contraseña"
                        onClick={() => this.setState(s => ({ showPassword: !s.showPassword }))}
                      >
                        {showPassword
                          ? <svg viewBox="0 0 24 24" fill="none" width="20" height="20"><path d="M3 3l18 18M10.5 10.5A3 3 0 0 0 13.5 13.5M6.3 6.3C4.3 7.7 2.8 9.7 2 12c1.7 4.4 6 7.5 10 7.5a10.5 10.5 0 0 0 5.7-1.8M9.9 5.1A10.4 10.4 0 0 1 12 4.5c4 0 8.3 3.1 10 7.5a11.1 11.1 0 0 1-2.1 3.3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
                          : <svg viewBox="0 0 24 24" fill="none" width="20" height="20"><path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" /></svg>
                        }
                      </button>
                    </div>

                    {/* Barra de fuerza */}
                    <div className="rp-strength-row">
                      <span>Seguridad: <strong className={strength.className}>{strength.label}</strong></span>
                      <div className="rp-strength-track">
                        <div className={`rp-strength-fill ${strength.className}`} style={{ width: `${strength.width}%` }}></div>
                      </div>
                    </div>
                    <p className="rp-help-text">Mínimo 6 caracteres. Con 8 o más la barra llega al nivel completo.</p>
                    {passwordError && <div className="rp-error">{passwordError}</div>}
                  </div>

                  {/* Confirmar contraseña */}
                  <div className="rp-field-group">
                    <label className="rp-label" htmlFor="rp-confirm">Repetir contraseña</label>
                    <div className="rp-input-wrap">
                      <svg className="rp-field-icon" viewBox="0 0 24 24" fill="none" width="20" height="20">
                        <path d="M19 11H5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2ZM7 11V7a5 5 0 0 1 10 0v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <circle cx="12" cy="16" r="1.5" fill="currentColor" />
                      </svg>
                      <input
                        id="rp-confirm"
                        type={showConfirm ? 'text' : 'password'}
                        className={`rp-input${confirmError ? ' rp-input--error' : ''}`}
                        placeholder="Confirma tu nueva contraseña"
                        value={form.password_confirmation}
                        onChange={e => this.onChange(e.target.value, 'password_confirmation')}
                        autoComplete="new-password"
                        minLength={6}
                      />
                      <button
                        type="button"
                        className="rp-toggle-btn"
                        aria-label="Mostrar u ocultar confirmación"
                        onClick={() => this.setState(s => ({ showConfirm: !s.showConfirm }))}
                      >
                        {showConfirm
                          ? <svg viewBox="0 0 24 24" fill="none" width="20" height="20"><path d="M3 3l18 18M10.5 10.5A3 3 0 0 0 13.5 13.5M6.3 6.3C4.3 7.7 2.8 9.7 2 12c1.7 4.4 6 7.5 10 7.5a10.5 10.5 0 0 0 5.7-1.8M9.9 5.1A10.4 10.4 0 0 1 12 4.5c4 0 8.3 3.1 10 7.5a11.1 11.1 0 0 1-2.1 3.3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
                          : <svg viewBox="0 0 24 24" fill="none" width="20" height="20"><path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" /></svg>
                        }
                      </button>
                    </div>
                    {confirmError && <div className="rp-error">{confirmError}</div>}
                  </div>

                  <button type="submit" className="rp-btn-submit" disabled={submitting}>
                    {submitting ? 'Guardando...' : (
                      <>
                        <svg viewBox="0 0 24 24" fill="none" width="18" height="18" style={{ marginRight: 8 }}>
                          <path d="M19 11H5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2ZM7 11V7a5 5 0 0 1 10 0v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        Guardar contraseña
                      </>
                    )}
                  </button>
                </form>
              </>
            )}

            {/* Link volver al login */}
            <div className="rp-back-wrap">
              <a className="rp-back-link" href="/login" onClick={this.goToLogin}>
                <svg viewBox="0 0 24 24" fill="none" width="16" height="16">
                  <path d="M19 12H5M12 5l-7 7 7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                Volver al inicio de sesión
              </a>
            </div>
          </section>

          <footer className="rp-footer">
            <div>¿Necesitas ayuda? <a href="https://braxo.io/" target="_blank" rel="noreferrer">Contáctanos en nuestra Web</a></div>
            <div>© 2026 Braxo. Todos los derechos reservados.</div>
          </footer>
        </main>
      </div>
    );
  }
}

export default ResetPassword;
